/**
 * Language and currency the proxy resolved for the request.
 */
export const LANGUAGE_CODE_HEADER = 'x-language-code'
export const CURRENCY_CODE_HEADER = 'x-currency-code'

/**
 * Cache-key contract for CDN-cached pages, shared by the proxy (which strips)
 * and the origin (which declares Vary). A request header that can change a
 * cached render must appear in exactly one of these lists:
 *
 *  - VARY_HEADERS:     kept and declared in the `Vary` response header, so the
 *                      Vercel CDN keys cached entries on it.
 *  - STRIPPED_HEADERS: deleted from the forwarded request on cached pages, so
 *                      the render can't depend on the per-user value.
 *
 * In neither → the value silently varies a shared cached render. In both →
 * a contradiction (keying on a header that's always absent). The two lists are
 * asserted disjoint in cacheHeaders.test.ts.
 *
 * The raw `user-agent` is neither stripped nor varied: origin code parses it
 * unconditionally, so instead of removing it (which would leave it parsing the
 * literal "undefined") the proxy overwrites it with CACHED_PAGE_USER_AGENT on
 * cached pages — a stable value that keeps the shared render deterministic.
 * Per-user device class still varies via the cloudfront-* headers above.
 *
 * This module must stay dependency-free so the proxy (middleware) can import it.
 */
export const VARY_HEADERS = [
  'x-host',
  'x-experiments',
  'x-vio-flutter',
  LANGUAGE_CODE_HEADER,
  CURRENCY_CODE_HEADER,
  'cloudfront-viewer-country',
  'cloudfront-is-mobile-viewer',
  'cloudfront-is-tablet-viewer',
  'cloudfront-is-desktop-viewer'
]

export const STRIPPED_HEADERS = ['cookie', 'x-client-ip', 'x-user-agent']

// Fixed user-agent forwarded for cached pages so the shared render can't depend
// on the real per-user value, while origin code still has a value to parse.
export const CACHED_PAGE_USER_AGENT = 'vio-cached-page'
